module.exports = __webpack_public_path__ + "media/3x/R-7e7ebf85.png";